import { openModal } from '@core/components/ModalStack';
import { SelectUsersModalProps } from './SelectUsersModal';

export async function openSelectUsersModal(props: SelectUsersModalProps) {
  const { SelectUsersModal } = await import('./SelectUsersModal');

  openModal(SelectUsersModal, props);
}
